import { render, staticRenderFns } from "./previewmaterialdetails.vue?vue&type=template&id=2b4d7ba4&scoped=true&"
import script from "./previewmaterialdetails.vue?vue&type=script&lang=js&"
export * from "./previewmaterialdetails.vue?vue&type=script&lang=js&"
import style0 from "./previewmaterialdetails.vue?vue&type=style&index=0&id=2b4d7ba4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b4d7ba4",
  null
  
)

export default component.exports